import useMutationEmailChannelCreateUpdate from "./email-channel-use-mutation-create-update";

export const emailChannelUseMutation = {
  createUpdate: useMutationEmailChannelCreateUpdate,
};
